import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "BulkActions" */ './lazyIndex'),
    { name: 'BulkActions' }
);

export const BulkActionProgressBar: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.BulkActionProgressBar
);
